export default __webpack_public_path__ + "static/media/Sopa-Do-Marisco.f094934a.jpg";